module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Regular.08e3322d.ttf";